import React, { Component } from 'react';
import SearchStore from '../../stores/SearchStore';
import { SearchTypes } from '../../constants/CentricConstants';
import { browserHistory } from 'react-router';

import { Card, CardActions, CardText } from 'material-ui/Card';
import DetailView from '../Common/DetailView';
import { FlatButton, LinearProgress, TextField } from 'material-ui';
import { Form } from 'formsy-react';
import AssetCard from '../Asset/AssetCard';
import Dialog from 'material-ui/Dialog';
import Snackbar from 'material-ui/Snackbar';

import ModuleActions from '../../actions/ModuleActionCreator';
import CategoryStore from '../../stores/CategoryStore';
import CategoryActions from '../../actions/CategoryActionCreator';
import MenuItem from 'material-ui/MenuItem';
import SelectField from '../Common/SelectField';
import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';
import { isSurroundedBy } from '../../utils/StringUtils';

const allowSearch = (searchTerm) => !!searchTerm && searchTerm.length > (isSurroundedBy(searchTerm, '"') ? 4 : 2);

class ResourceContentSearch extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            searchField:    this.props.location.query.searchTerm,
            categoryId:     Number(this.props.routeParams.categoryId) || null,
            includeSubcategories:   false,
            isFetching:     false,
            searchTerm:     this.props.location.query.searchTerm,
            results:        [],
            dialogOpen:     false,
            categoryFields:     [],
            selectedCategories: [],
            showMessage:    false,
            allowSearch:    allowSearch(this.props.location.query.searchTerm),
            sort: 'dateAdded'
        };
    }

    componentDidMount() {
        this.searchAssetsContent = this.searchAssetsContent.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onConfirmSearch = this.onConfirmSearch.bind(this);
        this.onCategoryChange = this.onCategoryChange.bind(this);
        this.onCategorySelect = this.onCategorySelect.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);

        this.listeners = [
            SearchStore.addListener(this.onSearchChange),
            CategoryStore.addListener(this.onCategoryChange)
        ];
        CategoryActions.getRoots();
        this.getInitialResults();
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
    }

    render() {
        return (
            <DetailView title="Resource" backButton={true} >
                <Form onValidSubmit={this.searchAssetsContent} >
                    <div className="cent-cards">
                        <Card className="cent-card">
                            <CardText>
                                <TextField
                                    value={this.state.searchField}
                                    floatingLabelText="Search text"
                                    onChange={this.onTextChange}
                                    fullWidth
                                 />
                                {this.state.categoryFields}
                                <Checkbox
                                    name="includeSubcategories"
                                    value={this.state.includeSubcategories}
                                    label="Include subcategories"
                                    onChange={this.onCheckboxChange}
                                    disabled={!this.state.categoryId}
                                />
                                <SelectField
                                    value={this.state.sort}
                                    name="Sort by"
                                    floatingLabelText="Sort by"
                                    onChange={(event, value) => this.setState({sort: value})}
                                >
                                    <MenuItem value="dateAdded" primaryText="Date created"/>
                                    <MenuItem value="dateUpdated" primaryText="Date updated"/>
                                </SelectField>
                            </CardText>
                            <CardActions>
                                <FlatButton type="Submit" label="Search" disabled={!this.state.allowSearch} />
                            </CardActions>
                            {!!this.state.isFetching && (<LinearProgress mode="indeterminate" />)}
                        </Card>
                    </div>
                </Form>
                <div className="cent-cards">
                    {this.state.results.map(module => (
                        <AssetCard key={module.id} data={module} url="/dashboard/module/{id}" search={this.state.searchTerm}/>
                    ))}
                </div>
                <Dialog
                    title="Resource search"
                    open={this.state.dialogOpen}
                    modal={false}
                    onRequestClose={this.onClose}
                    actions={[
                        <FlatButton key="cancel" label="Cancel" onTouchTap={this.onClose} />,
                        <FlatButton key="search" label="Continue" onTouchTap={this.onConfirmSearch}  />
                    ]}
                >
                    The search term "{this.state.searchTerm}" returned more than 100 results. Click Continue to show results or Cancel to refine search.
                </Dialog>
                <Snackbar
                    open={this.state.showMessage}
                    action="OK"
                    message={`No results found for "${this.state.searchTerm}"`}
                    onActionTouchTap={() => this.setState({showMessage: false})}
                    onRequestClose={() => this.setState({showMessage: false})}
                />
            </DetailView>
        );
    }

    getInitialResults() {
        if (!this.state.searchTerm) { return; } //guard
        this.onSearchChange();

        if (this.state.allowSearch) {
            this.searchAssetsContent();
        }
    }

    searchAssetsContent() {
        if (this.state.searchField.length >= 3) {
            let matchEntireText = false, searchField = this.state.searchField;
            const {categoryId, includeSubcategories} = this.state;
            this.setState({searchTerm: searchField});

            if (isSurroundedBy(searchField, '"')) {
                searchField = searchField.slice(1, searchField.length - 1);
                matchEntireText = true;
            }

            ModuleActions.searchMediaContent(searchField, {categoryId, includeSubcategories, matchEntireText, sort: this.state.sort});
            browserHistory.replace(`${this.props.location.pathname}?searchTerm=${this.state.searchField}`);
        }
    }

    onTextChange({target}) {
        this.setState({searchField: target.value, allowSearch: allowSearch(target.value)});
    }

    onSearchChange() {
        const search = SearchStore.getByKey(SearchTypes.RESOURCES_CONTENT);
        if (!search) { return; }

        if (!SearchStore.isFetching(SearchTypes.RESOURCES_CONTENT) && search.results.length === 0) {
            this.setState({showMessage: true, isFetching: false});
        } else if (search.results.length <= 100) {
            this.setState(search);
        } else {
            this.setState({dialogOpen: true});
        }
    }

    onCategorySelect(value, level) {
        if (this.state.selectedCategories.includes(value)) { return; }

        if (!value) {
            value = level > 1 ? this.state.selectedCategories[level - 2] : null;
        } else {
            CategoryActions.getChildren(value);
        }
        let changes = {categoryId: value};

        if (level > this.state.selectedCategories.length) {
            changes['selectedCategories'] = [...this.state.selectedCategories, value];
        } else {
            changes['selectedCategories'] = [...this.state.selectedCategories.slice(0, level - 1), value];
            changes['categoryFields'] = this.state.categoryFields.slice(0, level);
        }
        this.setState(changes);
    }

    onCheckboxChange({target}, value) {
        this.setState({[target.name]: value});
    }

    onCategoryChange() {
        const level = this.state.selectedCategories.length + 1;
        const categories = level === 1 ? CategoryStore.getRoots() : CategoryStore.getByParent(this.state.categoryId);
        const categoryField = (!categories || !categories.length) ? [] : (
            <SelectField
                key={level}
                name={`categoryFilter_${level}`}
                floatingLabelText={level === 1 ? "In category" : "In subcategory"}
                onChange={(event, value) => this.onCategorySelect(value, level)}
            >
                <MenuItem key="none" value={null} primaryText="All" label=" "/>
                {categories.map(({id, name}) => <MenuItem key={id} value={id} primaryText={name} />)}
            </SelectField>
        );

        this.setState({categoryFields: [...this.state.categoryFields, categoryField]});
    }

    onClose() {
        this.setState({dialogOpen: false, isFetching: false});
    }

    onConfirmSearch() {
        const search = SearchStore.getByKey(SearchTypes.RESOURCES_CONTENT);
        if (!!search) {
            this.setState(search);
        }
        this.onClose();
    }
}

export default ResourceContentSearch;
